import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-encuesta-satisfaccion-preguntas',
  templateUrl: './modal-encuesta-satisfaccion-preguntas.component.html',
  styleUrls: ['./modal-encuesta-satisfaccion-preguntas.component.scss']
})
export class ModalEncuestaSatisfaccionPreguntasComponent implements OnInit {

	public emojiList:string[];
	public preguntas: encuestaSatisfaccionPregunta[] = [];
	@ViewChildren('popover') popover:QueryList<NgbPopover>;

	public get hayPreguntasActivas(): boolean {
		return this.preguntas.some(t => t.activo);
	} 

	public get tipoPregunta(): typeof encuestaSatisfaccionTipoPregunta {
		return encuestaSatisfaccionTipoPregunta;
	}

	public emojiConfigForm:FormGroup;

	constructor(
		private _formBuilder: FormBuilder,
		public _activeModal: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.initEmojiList();
		this.inicializarListaDePreguntas();
		this.emojiConfigForm = this.initEmojiConfigForm();
	}

	private inicializarListaDePreguntas(): void {
		if(this.preguntas.length > 0) return;
		this.nuevaPregunta(encuestaSatisfaccionTipoPregunta.emoji);
		this.nuevaPregunta(encuestaSatisfaccionTipoPregunta.abierta);
		this.nuevaPregunta(encuestaSatisfaccionTipoPregunta.seleccionMultiple);
		this.nuevaPregunta(encuestaSatisfaccionTipoPregunta.checkbox);
	}

	public activar_desactivarPregunta(pregunta:encuestaSatisfaccionPregunta): void {
		pregunta.activo = !pregunta.activo;
	}

	public duplicarPregunta(pregunta: encuestaSatisfaccionPregunta): void {
		this.nuevaPregunta(pregunta.tipo, true);
	}

	public eliminarPregunta(pregunta:encuestaSatisfaccionPregunta): void {
		if(!pregunta.puedeEliminar) return;
		const index = this.preguntas.indexOf(pregunta);
		if(index <= 0) return;
		this.preguntas.splice(index, 1);
	}

	public subirPregunta(pregunta: encuestaSatisfaccionPregunta): void { 
		if(pregunta.orden == 1) return;
		const preguntaDeArriba = this.preguntas.find(t => t.orden == pregunta.orden - 1);
		preguntaDeArriba.orden++;
		pregunta.orden--;
	}

	public bajarPregunta(pregunta: encuestaSatisfaccionPregunta): void {
		if(pregunta.orden == this.preguntas.length) return;
		const preguntaDeAbajo = this.preguntas.find(t => t.orden == pregunta.orden + 1);
		preguntaDeAbajo.orden--;
		pregunta.orden++;
	}

	private nuevaPregunta(tipo: encuestaSatisfaccionTipoPregunta, puedeEliminar:boolean = false) {
		const orden = this.preguntas.length+1;
		let nuevaPregunta = new encuestaSatisfaccionPregunta(tipo, orden, puedeEliminar);
		this.preguntas.push(nuevaPregunta);
	}

	public indexToChar(index:number):string {
		return String.fromCharCode(65+index);
	}

	public nuevaRespuesta(pregunta: encuestaSatisfaccionPregunta): void {
		const numeroOpcion = pregunta.respuestas.length;
		const nuevaRespuesta = new encuestaSatisfaccionRespuesta(`Opción ${numeroOpcion+1}`, true);
		pregunta.respuestas.push(nuevaRespuesta);
	}

	public activar_desactivarRespuesta(respuesta: encuestaSatisfaccionRespuesta): void {
		respuesta.activo = !respuesta.activo;
	}

	public eliminarRespuesta(pregunta: encuestaSatisfaccionPregunta, respuesta: encuestaSatisfaccionRespuesta): void {
		if (!respuesta.puedeEliminar) return;
		const index = pregunta.respuestas.indexOf(respuesta);
		if (index <= 0) return;
		pregunta.respuestas.splice(index, 1);
	} 

	public guardarPreguntas(): void {
		this._activeModal.close(this.preguntas);
	}

	private initEmojiList(): void {
		this.emojiList = ['sentiment_very_dissatisfied', 'mood_bad',
		 'sentiment_dissatisfied', 'sentiment_neutral', 'sentiment_satisfied',
		 'sentiment_very_satisfied', 'thumb_up_off_alt', 'thumb_down_off_alt', 
		 'star', 'star_outline', 'star_half', 'done', 'done_all', 'close', 'do_disturb'];
	}

	private initEmojiConfigForm(): FormGroup {
		return this._formBuilder.group({
			icon: [undefined, Validators.required],
			color: ["#262626", Validators.required],
			label: [undefined, Validators.required],
		});
	}

	public respuestaSeleccionada: encuestaSatisfaccionRespuesta;
	public configurarRespuestaEmoji(respuesta: encuestaSatisfaccionRespuesta): void {
		this.respuestaSeleccionada = respuesta;
		this.emojiConfigForm.patchValue({
			icon: respuesta.emoji,
			color: respuesta.emojiColor,
			label: respuesta.label
		})
		
		window.setTimeout(() => {
			const radioButton = document.querySelector(`[value='${respuesta.emoji}']`);
			radioButton.parentElement.classList.add('active');
		}, 250)
	}
	public setEmojiIcon(emoji:string): void {
		this.emojiConfigForm.get('icon').setValue(emoji);
	}
	public aplicarCambiosARespuestaEmoji(): void {
		const values = this.emojiConfigForm.value;
		this.respuestaSeleccionada.emoji = values.icon;
		this.respuestaSeleccionada.emojiColor = values.color;
		this.respuestaSeleccionada.label = values.label;
		this.emojiConfigForm.reset({color: '#262626'});
		this.respuestaSeleccionada = null;
		this.popover.forEach(t => {
			if(!t.isOpen()) return;
			t.close();
		})
	}
}

export enum encuestaSatisfaccionTipoPregunta {
	abierta = 1,
	checkbox = 2,
	seleccionMultiple = 3,
	emoji = 4
}

export class encuestaSatisfaccionPregunta {
	constructor(tipoPregunta: encuestaSatisfaccionTipoPregunta, 
		orden:number, puedeEliminar:boolean) {

		this.tipo = tipoPregunta;
		this.titulo = "escriba aquí su pregunta";
		this.activo = false;
		this.orden = orden;
		this.puedeEliminar = puedeEliminar;
		this.respuestas = [];

		this.puedeAgregarMasRespuestas = tipoPregunta == encuestaSatisfaccionTipoPregunta.seleccionMultiple
			|| tipoPregunta == encuestaSatisfaccionTipoPregunta.checkbox;
		
		switch(tipoPregunta){
			case encuestaSatisfaccionTipoPregunta.seleccionMultiple:
			case encuestaSatisfaccionTipoPregunta.checkbox:
				this.respuestas.push(new encuestaSatisfaccionRespuesta("Opción 1"));
				this.respuestas.push(new encuestaSatisfaccionRespuesta("Opción 2"));
				break;
			case encuestaSatisfaccionTipoPregunta.emoji:
				this.respuestas.push(new encuestaSatisfaccionRespuesta("Mala").setEmoji('sentiment_dissatisfied', '#262626'));
				this.respuestas.push(new encuestaSatisfaccionRespuesta("Regular").setEmoji('sentiment_neutral', '#262626'));
				this.respuestas.push(new encuestaSatisfaccionRespuesta("Buena").setEmoji('sentiment_satisfied', '#262626'));
				this.respuestas.push(new encuestaSatisfaccionRespuesta("Excelente").setEmoji('sentiment_very_satisfied', '#262626'));
				break;
				default:
				this.respuestas.push(new encuestaSatisfaccionRespuesta(''));
		}
	}

	public id:number;
	public orden:number;
	public tipo: encuestaSatisfaccionTipoPregunta;
	public titulo:string;
	public activo:boolean;
	public puedeEliminar:boolean;
	public respuestas:any[];
	public puedeAgregarMasRespuestas:boolean;

	public isEmoji(): boolean {
		return this.tipo == encuestaSatisfaccionTipoPregunta.emoji;
	}
}

export class encuestaSatisfaccionRespuesta {
	constructor(label:string, puedeEliminar:boolean=false) {
		this.label = label;
		this.puedeEliminar = puedeEliminar;
		this.activo = true;
	}

	public id:number;
	public label:string;
	public emoji: string;
	public emojiColor: string;
	public puedeEliminar:boolean;
	public activo:boolean;

	public setEmoji(emojiIcon: string, emojiColor:string): encuestaSatisfaccionRespuesta {
		this.emoji = emojiIcon;
		this.emojiColor = emojiColor;
		this.activo = false;
		return this;
	}
}